import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";
import { getFunFactApi, getImagesApi } from '../http/http';
import { FaBarsStaggered, FaCopyright, FaSpinner, FaXmark } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Player/UI/Loader/Loader';
import Drawer from '../components/Drawer';

const HomePage = () => {

    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true);
    const [drawer, setDrawer] = useState(false);
    const [funFact, setFunFact] = useState(null);
    const [funFactLoading, setFunFactLoading] = useState(true);

    const fetchImages = async () => {
        try {
            setLoader(true);
            const response = await getImagesApi();
            console.log(response, 'resposne....');
            setData(response?.data);
            setLoader(false);

        } catch (error) {
            setLoader(false);

            console.log(error, 'error----');
        }
    }

    const fetchFunFact = async () => {
        try {
            setFunFactLoading(true);
            const response = await getFunFactApi();
            console.log(response?.data?.[0]?.english, 'resposne....');
            setFunFact(response?.data?.[0]?.english)
            setFunFactLoading(false);


        } catch (error) {
            console.log(error, 'error----');
            setFunFactLoading(false);

        }
    }

    useEffect(() => {
        fetchImages();
        fetchFunFact();
    }, []);
    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                    <div className={classes.nav_items}>
                        <button type="button" className={`${classes.nav_item} ${classes.active}`}>
                            Home
                        </button>
                        <button type="button" className={classes.nav_item}
                            onClick={() => {
                                navigate("/category");
                            }}
                        >
                            Categories
                        </button>
                        {/* <button type="button" className={classes.nav_item}>
                            Terms & Conditions
                        </button> */}
                        <button type="button" className={classes.nav_item_btn}
                            onClick={() => {
                                navigate("/category");
                            }}
                        >
                            Watch Now
                        </button>
                    </div>

                    <button type="button" className={classes.menu_bar}
                        onClick={() => {
                            setDrawer(!drawer)
                        }}
                    >
                        {drawer ?
                            <FaXmark
                                className={classes.menu_bar_icon}
                            />
                            :
                            <FaBarsStaggered className={classes.menu_bar_icon} />
                        }
                    </button>
                </nav>
            </header>

            <section className={classes.section_landing_page}>
                <div className={classes.grid_container}>
                    <div className={classes.grid_section_one}>
                        <h1 className={classes.heading_one}>
                            <span className={classes.highlight_orange}>
                                DIVE
                            </span>{" "}
                            INTO THE
                        </h1>
                        <h1 className={classes.heading_two}>
                            GREATNESS OF </h1>
                        <h1 className={classes.heading_three}>
                            <span className={classes.highlight_green}>
                                LEARNING.
                            </span>
                        </h1>

                        <p className={classes.portal_description}>
                            Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                        </p>

                        <button type="button" className={classes.watch_now_btn}
                            onClick={() => {
                                navigate("/category");
                            }}
                        >
                            Watch Now <FaChevronRight className={classes.arrow_right} />
                        </button>

                        <div className={classes.grid_sub_container}>
                            <div className={classes.kids_image_container}>
                                <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                            </div>
                            <div className={classes.kids_info}>
                                <p className={classes.kids_info_text_one}>Made For</p>
                                <p className={classes.kids_info_text_two}>- Kids</p>
                            </div>
                        </div>
                    </div>
                    <div className={classes.grid_section_two}>
                        <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />
                    </div>

                </div>
                <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

            </section>

            <section className={classes.funFactSection}>
                <div className={classes.funFactInner}>
                    {/* Left */}
                    <div className={classes.funFactLeft}>
                        <div className={classes.funFactTag}>Did You Know?</div>

                        <h2 className={classes.funFactTitle}>
                            Fun <span>Facts</span>
                        </h2>

                        <p className={classes.funFactDesc}>
                            A quick bite of knowledge for curious kids! Read a fun fact every day and
                            learn something new in a super simple way.
                        </p>

                        {/* <div className={classes.funFactActions}>
                            <button
                                type="button"
                                className={classes.primaryBtn}
                                onClick={() => navigate("/fun-facts")}
                            >
                                Explore More <span className={classes.arrow}>›</span>
                            </button>

                            <button
                                type="button"
                                className={classes.secondaryBtn}
                                onClick={() => navigate("/categories")}
                            >
                                View Categories
                            </button>
                        </div> */}
                    </div>

                    {/* Right (Fact Card) */}
                    <div className={classes.funFactRight}>
                        <div className={classes.factCard}>
                            <div className={classes.factTop}>
                                <div className={classes.factIcon}>💡</div>
                                <div>
                                    <div className={classes.factHeading}>Today’s Fun Fact</div>
                                    <div className={classes.factSub}>Short • Simple • Cool</div>
                                </div>
                                <div className={classes.factBadge}>NEW</div>
                            </div>

                            <div className={classes.factBubble}>
                                <div className={classes.factEmoji}>🦒</div>
                                <p className={classes.factText}>
                                    {funFactLoading ? <div className={classes.spinner}></div> : funFact}
                                </p>
                            </div>

                            <div className={classes.factFooter}>
                                <div className={classes.factMeta}>
                                    <span>📚 Learn daily</span>
                                    <span>⭐ Kids friendly</span>
                                </div>

                                <button
                                    type="button"
                                    className={classes.factBtn}
                                    onClick={() => fetchFunFact()}
                                >
                                    Next Fact
                                </button>
                            </div>
                        </div>

                        <div className={classes.factBlobA} />
                        <div className={classes.factBlobB} />
                    </div>
                </div>
            </section>

            <section className={classes.section_categories_page}>
                <div className={classes.container}>
                    <h1 className={classes.section_categories_title}>Providing Good Qualities For Your Loving Kids</h1>
                    <div className={classes.section_categories_grid}>

                        <div className={classes.category_item}
                            onClick={() => {
                                navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=3");
                            }}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/rhymes.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Ryhmes</h1>
                            {/* <p className={classes.category_item_description}>
                                Kids rhymes are fun and educational songs that help young children learn language, rhythm, through catchy tunes and playful lyrics.
                            </p> */}

                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={() => {
                                        navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=3");
                                    }}
                                >
                                    Watch Now
                                </button>
                            </div>
                        </div>

                        <div className={classes.category_item}
                            onClick={() => {
                                navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=2");
                            }}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/book.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Learning</h1>
                            {/* <p className={classes.category_item_description}>
                                Kids learning is all about helping children grow through fun, play, and simple lessons that build language, thinking, and social skills.
                            </p> */}
                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={() => {
                                        navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=2");
                                    }}
                                >
                                    Watch Now
                                </button>
                            </div>
                        </div>

                        <div className={classes.category_item}
                            onClick={() => {
                                navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=4");
                            }}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/fairytale.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Stories</h1>
                            {/* <p className={classes.category_item_description}>
                                Kids stories spark imagination and teach values through fun characters and adventures, helping children learn and grow in a joyful way.
                            </p> */}
                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={() => {
                                        navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=4");
                                    }}
                                >
                                    Watch Now
                                </button>
                            </div>
                        </div>

                        <div className={classes.category_item}
                            onClick={() => {
                                navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=1");
                            }}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/digital-drawing.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Drawing</h1>
                            {/* <p className={classes.category_item_description}>
                                Kids drawing is a fun way to learn step-by-step sketching and coloring. Follow easy lessons to draw cute animals, cartoons, and everyday objects—perfect for building creativity and confidence.
                            </p> */}
                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={() => {
                                        navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=1");
                                    }}
                                >
                                    Watch Now
                                </button>
                            </div>
                        </div>

                        {/* <div className={classes.category_item}
                            onClick={() => {
                                navigate("/category/gaming");
                            }}
                        >
                            <div className={classes.category_item_image}>
                                <img src="/assets/images/game-console.png" alt="rhyme" className={classes.category_image} />
                            </div>
                            <h1 className={classes.category_item_heading}>Kids Gaming</h1>
                            <p className={classes.category_item_description}>
                                Jump into a world of fun! Play kid-friendly games with cute characters, quick levels, and cool rewards—made for endless entertainment and learning.
                            </p>
                            <div className={classes.category_button_container}>
                                <button type="button" className={classes.category_button}
                                    onClick={() => {
                                        navigate("/category/gaming");
                                    }}
                                >
                                    Play Now
                                </button>
                            </div>
                        </div> */}

                    </div>

                    <section className={classes.kidsGamesSection}>
                        <div className={classes.kidsGamesInner}>
                            {/* Left Content */}
                            <div className={classes.kidsGamesLeft}>
                                <div className={classes.kidsGamesTag}>Popular</div>

                                <h2 className={classes.kidsGamesTitle}>
                                    Kids <span>Games</span>
                                </h2>

                                <p className={classes.kidsGamesDesc}>
                                    Fun and safe mini-games for kids! Play puzzles, racing, memory games and
                                    quick challenges that improve focus, thinking and reflexes—made for
                                    learning through play.
                                </p>

                                <div className={classes.kidsGamesPoints}>
                                    <div className={classes.point}>🎮 Easy to play</div>
                                    <div className={classes.point}>🧠 Brain boosting</div>
                                </div>

                                <div className={classes.kidsGamesActions}>
                                    <button
                                        type="button"
                                        className={classes.primaryBtn}
                                        onClick={() => navigate("/category/content/Game%20Box?main_category_id=4")}
                                    >
                                        Play Games
                                        {/* <span className={classes.arrow}>›</span> */}
                                        <span className={classes.arrow}><FaArrowRight className={classes.arrow_icon} /></span>
                                    </button>

                                    {/* <button
                                        type="button"
                                        className={classes.secondaryBtn}
                                        onClick={() => navigate("/categories")}
                                    >
                                        View Categories
                                    </button> */}
                                </div>
                            </div>

                            {/* Right Preview */}
                            <div className={classes.kidsGamesRight}>
                                <div className={classes.gamesPreviewCard}>
                                    <div className={classes.previewTop}>
                                        <div className={classes.previewIcon}>🎯</div>
                                        <div>
                                            <div className={classes.previewTitle}>Mini Games Pack</div>
                                            <div className={classes.previewSub}>Puzzles • Sports • Casual</div>
                                        </div>
                                        <div className={classes.previewBadge}>NEW</div>
                                    </div>

                                    <div className={classes.previewGrid}>
                                        <div className={classes.gameTile}>
                                            <img
                                                src="https://content.rashigames.com/games/category-thumbnails/puzzle.jpg"
                                                alt="Puzzle"
                                                className={classes.tileImg}
                                            />
                                            <div className={classes.tileName}>Puzzle</div>
                                        </div>

                                        <div className={classes.gameTile}>
                                            <img
                                                src="https://content.rashigames.com/games/category-thumbnails/sports.jpg"
                                                alt="Racing"
                                                className={classes.tileImg}
                                            />
                                            <div className={classes.tileName}>Sports</div>
                                        </div>

                                        <div className={classes.gameTile}>
                                            <img
                                                src="https://content.rashigames.com/games/category-thumbnails/mind.jpg"
                                                alt="Memory"
                                                className={classes.tileImg}
                                            />
                                            <div className={classes.tileName}>Mind</div>
                                        </div>

                                        <div className={classes.gameTile}>
                                            <img
                                                src="https://content.rashigames.com/games/category-thumbnails/casual.jpg"
                                                alt="Words"
                                                className={classes.tileImg}
                                            />
                                            <div className={classes.tileName}>Casual</div>
                                        </div>
                                    </div>

                                    <div className={classes.previewFooter}>
                                        <div className={classes.previewMeta}>
                                            <span>👧 Age 2–10</span>
                                            <span>⏱️ Quick Play</span>
                                        </div>

                                        <button
                                            type="button"
                                            className={classes.previewPlayBtn}
                                            onClick={() => navigate("/category/content/Game%20Box?main_category_id=4")}
                                        >
                                            Start Playing
                                        </button>
                                    </div>
                                </div>

                                <div className={classes.kidsBlobA} />
                                <div className={classes.kidsBlobB} />
                            </div>
                        </div>
                    </section>

                    <section className={classes.kidsDrawingSection}>
                        <div className={classes.kidsDrawingInner}>
                            {/* Left */}
                            <div className={classes.kidsDrawingLeft}>
                                <div className={classes.kidsDrawingTag}>Creative</div>

                                <h2 className={classes.kidsDrawingTitle}>
                                    Kids <span>Drawing</span>
                                </h2>

                                <p className={classes.kidsDrawingDesc}>
                                    Learn to draw step-by-step with simple shapes and fun tutorials. Create cute
                                    animals, cartoons, fruits, and everyday objects—then color them and make your
                                    own masterpiece!
                                </p>

                                <div className={classes.kidsDrawingPoints}>
                                    <div className={classes.dPoint}>✏️ Easy step-by-step</div>
                                    <div className={classes.dPoint}>🎨 Color & shade</div>
                                    <div className={classes.dPoint}>🧩 Improve focus</div>
                                </div>

                                <div className={classes.kidsDrawingActions}>
                                    <button
                                        type="button"
                                        className={classes.primaryBtn}
                                        onClick={() => navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=1")}
                                    >
                                        Start Drawing <span className={classes.arrow}><FaArrowRight className={classes.arrow_icon} /></span>
                                    </button>

                                </div>
                            </div>

                            {/* Right */}
                            <div className={classes.kidsDrawingRight}>
                                <div className={classes.drawingPreviewCard}>
                                    <div className={classes.drawingTop}>
                                        <div className={classes.drawingIcon}>🎨</div>
                                        <div>
                                            <div className={classes.drawingName}>How to Draw</div>
                                            <div className={classes.drawingSub}>Animals • Fruits • Cartoons</div>
                                        </div>
                                        <div className={classes.drawingBadge}>STEP</div>
                                    </div>

                                    {/* Preview Image */}
                                    <div className={classes.drawingCanvas}>
                                        <img
                                            src="https://content.rashigames.com/thumbnails/cat-thumbnails/drawing.png"
                                            alt="Drawing preview"
                                            className={classes.drawingImg}
                                        />

                                        {/* Small steps chips */}
                                        <div className={classes.stepChips}>
                                            <span className={classes.stepChip}>1</span>
                                            <span className={classes.stepChip}>2</span>
                                            <span className={classes.stepChip}>3</span>
                                        </div>
                                    </div>

                                    {/* Bottom */}
                                    <div className={classes.drawingFooter}>
                                        <div className={classes.drawingMeta}>
                                            <span>🕒 2–5 min</span>
                                            <span>⭐ Beginner</span>
                                        </div>

                                        <button
                                            type="button"
                                            className={classes.drawingBtn}
                                            onClick={() => navigate("/category/content/Magic%20Kids?main_category_id=1&sub_category_id=1")}
                                        >
                                            Watch Lessons
                                        </button>
                                    </div>
                                </div>

                                <div className={classes.drawBlobA} />
                                <div className={classes.drawBlobB} />
                            </div>
                        </div>
                    </section>


                    <section className={classes.guessWordSection}>
                        <div className={classes.guessWordInner}>
                            {/* Left */}
                            <div className={classes.guessWordLeft}>
                                <div className={classes.guessWordTag}>New Game</div>

                                <h2 className={classes.guessWordTitle}>
                                    Guess The <span>Word</span>
                                </h2>

                                <p className={classes.guessWordDesc}>
                                    A fun word puzzle for kids! Look at the picture, choose the correct letters,
                                    and complete the word. Improve spelling, memory, and vocabulary in a playful way.
                                </p>

                                <div className={classes.guessWordStats}>
                                    <div className={classes.statBox}>
                                        <div className={classes.statNum}>1000+</div>
                                        <div className={classes.statLabel}>Words</div>
                                    </div>
                                    <div className={classes.statBox}>
                                        <div className={classes.statNum}>3</div>
                                        <div className={classes.statLabel}>Difficulty Levels</div>
                                    </div>
                                </div>

                                <div className={classes.guessWordActions}>
                                    <button
                                        type="button"
                                        className={classes.primaryBtn}
                                        onClick={() => navigate("/word-game-details")}
                                    >
                                        Play Now
                                        <span className={classes.arrow}><FaArrowRight className={classes.arrow_icon} /></span>
                                    </button>

                                    {/* <button
                                        type="button"
                                        className={classes.secondaryBtn}
                                        onClick={() => navigate("/category/gaming")}
                                    >
                                        Explore More Games
                                    </button> */}
                                </div>
                            </div>

                            {/* Right */}
                            {/* <div className={classes.guessWordRight}> */}
                            {/* <div className={classes.gameCard}> */}

                            {/* <img src="/assets/images/guess-word.png" alt="guess word" className={classes.guessWordImage} /> */}

                            {/* <div className={classes.gameCardTop}>
                                        <div className={classes.gameIcon}>🔤</div>
                                        <div>
                                            <div className={classes.gameName}>Guess The Word</div>
                                            <div className={classes.gameHint}>Hint: It’s a fruit 🍎</div>
                                        </div>
                                    </div>

                                    <div className={classes.wordRow}>
                                        <span className={classes.letterBox}>A</span>
                                        <span className={classes.letterBox}>P</span>
                                        <span className={classes.letterBox}>_</span>
                                        <span className={classes.letterBox}>L</span>
                                        <span className={classes.letterBox}>E</span>
                                    </div>

                                    <div className={classes.choicesRow}>
                                        <button className={classes.choiceChip} type="button">P</button>
                                        <button className={classes.choiceChip} type="button">E</button>
                                        <button className={classes.choiceChip} type="button">A</button>
                                        <button className={classes.choiceChip} type="button">M</button>
                                    </div>

                                    <div className={classes.cardFooter}>
                                        <div className={classes.progressWrap}>
                                            <div className={classes.progressText}>Level 1</div>
                                            <div className={classes.progressBar}>
                                                <div className={classes.progressFill} />
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className={classes.cardPlayBtn}
                                            onClick={() => navigate("/games/guess-the-word")}
                                        >
                                            Start
                                        </button>
                                    </div> */}
                            {/* </div> */}

                            {/* <img src="/assets/images/guess-word.png" alt="guess word" className={classes.guessWordImage} /> */}


                            <div className={classes.kidsDrawingRight}>
                                <div className={classes.drawingPreviewCard}>
                                    <div className={classes.drawingTop}>
                                        <div className={classes.drawingIcon}>🎨</div>
                                        <div>
                                            <div className={classes.drawingName}>Word Whirl</div>
                                            <div className={classes.drawingSub}>Guess • Learn • Play</div>
                                        </div>
                                        {/* <div className={classes.drawingBadge}>STEP</div> */}
                                    </div>

                                    {/* Preview Image */}
                                    <div className={classes.drawingCanvas}>
                                        <img
                                            src="/assets/images/guess-word.png"
                                            alt="Drawing preview"
                                            className={classes.drawingImg}
                                        />

                                        {/* Small steps chips */}
                                        {/* <div className={classes.stepChips}>
                                            <span className={classes.stepChip}>1</span>
                                            <span className={classes.stepChip}>2</span>
                                            <span className={classes.stepChip}>3</span>
                                        </div> */}
                                    </div>

                                    {/* Bottom */}
                                    <div className={classes.drawingFooter}>
                                        <div className={classes.drawingMeta}>
                                            {/* <span>🕒 2–5 min</span> */}
                                            {/* <span>⭐ Beginner</span> */}
                                            <div className={classes.point}>🎮 Easy to play</div>
                                            <div className={classes.point}>🧠 Brain boosting</div>
                                            <div className={classes.point}>⭐ Difficulty Levels</div>
                                        </div>

                                        <button
                                            type="button"
                                            className={classes.drawingBtn}
                                            onClick={() => navigate("/word-game-details")}
                                        >
                                            Start Playing
                                        </button>
                                    </div>
                                </div>

                                {/* <div className={classes.drawBlobA} /> */}
                                {/* <div className={classes.drawBlobB} /> */}
                                {/* </div> */}

                                <div className={classes.bubble1} />
                                <div className={classes.bubble2} />
                            </div>
                        </div>
                    </section>

                    <section className={classes.ticTacSection}>
                        <div className={classes.ticTacInner}>
                            {/* Left */}
                            <div className={classes.ticTacLeft}>
                                <div className={classes.ticTacTag}>Classic Game</div>

                                <h2 className={classes.ticTacTitle}>
                                    Tic Tac <span>Toe</span>
                                </h2>

                                <p className={classes.ticTacDesc}>
                                    Play the timeless X-O game! Take turns, think ahead, and try to make three in
                                    a row. Great for improving logic, strategy, and quick thinking—super fun for kids.
                                </p>

                                <div className={classes.ticTacPoints}>
                                    <div className={classes.tPoint}>❌ Easy rules</div>
                                    <div className={classes.tPoint}>⭕ Brain & logic</div>
                                </div>

                                <div className={classes.ticTacActions}>
                                    <button
                                        type="button"
                                        className={classes.primaryBtn}
                                        onClick={() => navigate("/xo-game-details")}
                                    >
                                        Play Now <span className={classes.arrow}><FaArrowRight className={classes.arrow_icon} /></span>
                                    </button>

                                </div>
                            </div>

                            {/* Right */}
                            <div className={classes.ticTacRight}>
                                {/* <div className={classes.ticTacCard}> */}
                                {/* <div className={classes.ticTacTop}>
                                        <div className={classes.ticTacIcon}>❌⭕</div>
                                        <div>
                                            <div className={classes.ticTacName}>Tic Tac Toe</div>
                                            <div className={classes.ticTacSub}>Make 3 in a row</div>
                                        </div>
                                        <div className={classes.ticTacBadge}>VS</div>
                                    </div>

                                    <div className={classes.board}>
                                        {Array.from({ length: 9 }).map((_, i) => (
                                            <div key={i} className={classes.cell}>
                                                {i === 0 ? "X" : i === 4 ? "O" : i === 8 ? "X" : ""}
                                            </div>
                                        ))}
                                    </div>

                                    <div className={classes.ticTacFooter}>
                                        <div className={classes.turnPill}>Your turn: ❌</div>

                                        <button
                                            type="button"
                                            className={classes.ticTacBtn}
                                            onClick={() => navigate("/games/tic-tac-toe")}
                                        >
                                            Start
                                        </button>
                                    </div> */}
                                {/* </div> */}

                                <div className={classes.drawingPreviewCard}>
                                    <div className={classes.drawingTop}>
                                        <div className={classes.drawingIcon}>⭕</div>
                                        <div>
                                            <div className={classes.drawingName}>Tic Tac Toe</div>
                                            <div className={classes.drawingSub}>Fun • Exciting • Brainstorming</div>
                                        </div>
                                        {/* <div className={classes.drawingBadge}>STEP</div> */}
                                    </div>

                                    {/* Preview Image */}
                                    <div className={classes.drawingCanvas}>
                                        <img
                                            src="/assets/images/tic-tac-toe.png"
                                            alt="Drawing preview"
                                            className={classes.drawingImg}
                                        />

                                        {/* Small steps chips */}
                                        {/* <div className={classes.stepChips}>
                                            <span className={classes.stepChip}>1</span>
                                            <span className={classes.stepChip}>2</span>
                                            <span className={classes.stepChip}>3</span>
                                        </div> */}
                                    </div>

                                    {/* Bottom */}
                                    <div className={classes.drawingFooter}>
                                        <div className={classes.drawingMeta}>
                                            {/* <span>🕒 3 Levels</span> */}
                                            {/* <span>⭐ Beginner</span> */}
                                            <div className={classes.point}>🎮 Easy to play</div>
                                            <div className={classes.point}>🧠 Brain boosting</div>
                                        </div>

                                        <button
                                            type="button"
                                            className={classes.drawingBtn}
                                            onClick={() => navigate("/xo-game-details")}
                                        >
                                            Start Playing
                                        </button>
                                    </div>
                                </div>

                                <div className={classes.ticBlobA} />
                                <div className={classes.ticBlobB} />
                            </div>
                        </div>
                    </section>

                </div>
            </section>

            <section className={classes.section_product_page}>
                <div className={classes.container_product}>
                    <h1 className={classes.section_product_page_heading}>Special Care For Your Children</h1>

                    <div className={classes.section_product_page_grid}>
                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                                Content Type
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                                8 Categories
                            </p>
                        </div>

                        <div className={classes.divider}>
                        </div>

                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                                Browser Over
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                                250+ Videos
                            </p>
                        </div>
                    </div>

                    <h1 className={classes.section_product_page_heading2}>
                        Unlocking skills, One video at a time 🚀
                    </h1>

                    <p className={classes.section_product_page_paragraph}>
                        Unlock joyful learning with Little Masters: Videos that spark brilliance. Explore, Watch, Learn!
                    </p>
                </div>

                <img src="/assets/images/Book Illustration.png" alt="Book" className={classes.image_book_illustration} />
                <img src="/assets/images/World Illustration.png" alt="World" className={classes.image_world_illustration} />

                {loader ? <Loader on={loader} /> : (
                    <>
                        <div className={classes.section_carousel_marquee}>
                            <div className={classes.section_carousel_sub_container}>
                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}

                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </>
                )}


            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>
                        
                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                Rainboo Softmate Pvt Ltd
                            </p>
                        </div>
                    </div>


                </div>
            </section>

            <Drawer setDrawer={setDrawer} drawer={drawer} />

        </main>
    )
}

export default HomePage;

const dummydata = [
    {
        image: ""
    }
]